import Header from 'pages/Admin/AccountLogsList/components/Header';
import { createContext, useContext, useMemo, useState } from 'react';
import { Vehicle } from 'types/vehicle';

type HeaderContextType = {
  mobileFiltersOpened: boolean;
  toggleMobileFilters: () => void;
};

const defaultValue: HeaderContextType = {
  mobileFiltersOpened: false,
  toggleMobileFilters: () => {}
};

export const HeaderContext = createContext(defaultValue);

export const VehicleListHeaderContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const value = useMemo(
    () => ({
      mobileFiltersOpened: isOpen,
      toggleMobileFilters: () => setIsOpen(curr => !curr)
    }),
    [isOpen]
  );

  return <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>;
};

export const useHeaderContext = () => {
  const context = useContext(HeaderContext);
  return context;
};
